<template>
  <v-container class="documents">
    <div class="d-flex mt-5" :class="$root.mobile ? 'justify-center' : ''">
      <img
        src="../assets/app.jpeg"
        class="logo"
        :width="$root.mobile ? '100px' : '200px'"
        height="50px"
      />
    </div>
    <div
      class="mt-3"
      :class="$root.mobile ? 'subtitle-1  text-center' : 'title'"
    >
      Rental Application for Alpine Leasing
    </div>
    <v-alert type="success" class="mt-3" v-if="isSuccess">
      Your payment processed successfully!
    </v-alert>
    <Terms />
  </v-container>
</template>

<script>
import Terms from "../documents/Terms";
export default {
  components: { Terms },
  computed: {
    isSuccess() {
      return this.$route.name === "success";
    }
  }
};
</script>

<style>
.logo {
  object-fit: contain;
}
.documents {
  max-width: 900px;
}
.documents .title {
  font-weight: normal;
}
</style>
